import { Navigate, useParams, useLocation } from 'react-router-dom';

export default function OrgChartPage() {
  const { companyId } = useParams();
  const location = useLocation();
  return (
    <Navigate replace to={`/company/${companyId}/organization${location.search}${location.hash}`} />
  );
}
